import axios from "axios"
import { Toast } from "vant"

 
let firstHost=window.location.hostname.split(".")[0];
let Api_Base_Url_Cahd= process.env.VUE_APP_SERVER_URL_CAHD.replace("{0}",firstHost);
let Api_Base_Url_User= process.env.VUE_APP_SERVER_URL_USER.replace("{0}",firstHost);
// console.log("outputDir:",process.env.outputDir); 
// console.log("process.env.VUE_APP_SERVER_URL_CAHD:",process.env.VUE_APP_SERVER_URL_CAHD);
 console.log("process.env.NODE_ENV:",process.env.NODE_ENV);
 console.log("Api_Base_Url_Cahd:",Api_Base_Url_Cahd);
// console.log("Api_Base_Url_User:",Api_Base_Url_User); 
// axios.defaults.timeout = 3000;
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断    
    // const token = localStorage.getItem("topicToken");
    // if(token.length>0){
    //   config.headers['SX-TOKEN'] =token
    // }
    config.headers['Content-Type'] = 'application/json; charset=UTF-8';
    // // 加loading
    // Toast.loading({
    //   duration: 0, // 持续展示 toast
    //   message: '加载中...',
    //   forbidClick: true,
    //   loadingType: 'spinner',
    // });
    return config;
  },
  error => {
    return Promise.error(error);
  });
// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      Toast.clear();//清理弹窗
      return Promise.resolve(response);
    } else {
      Toast.clear();//清理弹窗
      return Promise.reject(response);
    }
  },
  // 然后根据返回的状态码进行一些操作，可自行扩展
  error => {
    if(error.message.includes('Network Error')){
      Toast({message: '网络错误,请检查网络连接',duration: 2000});
      return; 
    }
    else if(error.message.includes('timeout')){
      Toast({message: '网络超时,请稍后重试',duration: 2000});
      return ; 
    }
    else if (error.response && error.response.status) {
      switch (error.response.status) {
        //token过期，清除本地token
        case 403:
          Toast({message: 'token失效，请关闭重连',duration: 2000}); 
          // 清除token
          localStorage.removeItem('topicToken');
          break;
        //请求不存在
        case 404:
          Toast({message: '网络请求不存在',duration: 2000});  
          break;
        //请求不存在
        case 500:
          Toast({message: '服务器异常',duration: 2000}); 
          break;
        //其他错误，直接抛出错误提示
        //用户被登出
        case 401:
          
          break;
        default:
          if(error.response.data && error.response.data.message){
            Toast({message: error.response.data.message,duration: 2000});  
          }
      }
      return Promise.reject(error.response);
    }
  }
);

/**
 * 为GET请求passport域名
 *
 */
function getPassport(url,params) {
  return new Promise((resolve, reject) => {
    axios
      .request({
        url: url.indexOf("http")==-1? Api_Base_Url_User + url : url,
        method: "get",
        params: {...params}
      })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  })
}
/**
 * methods请求为GET
 *
 */
function get(url,params,haveBaseApi=true) { 
  let apiUrl = haveBaseApi? `${Api_Base_Url_Cahd}${url}` : url;
  //console.log("apiUrl=",apiUrl);
  return new Promise((resolve, reject) => {
    axios
      .request({
        //type:'Cahd',
        url: apiUrl,
        method: "get",
        params: {...params},
        //headers
      })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  })
}

/**
 * methods请求为GET,需要token
 *
 */
function getByToken(url,params,token) {
  let headers = filterHeader();
  headers['SX-TOKEN'] = token;
  
  return new Promise((resolve, reject) => {
    axios
      .request({
        //type:'Cahd',
        url: Api_Base_Url_Cahd+url,
        method: "get",
        params: {...params},
        headers
      })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  })
}

/**
 * methods 请求为POST
 * data 请求格式
 */

function post(url, data,haveBaseApi=true) {
  let headers = filterHeaderNew();
  let apiUrl =haveBaseApi? (Api_Base_Url_Cahd + url):url;
  return new Promise((resolve, reject) => {
    axios.request({
      url: apiUrl,
      method: 'post',
      data: data,
     // params: { ...data },
      // transformRequest: [
      //   function (data2) {
      //     data = JSON.stringify(data2)
      //   }
      // ],
      headers
    }).then(res => {
      resolve(res)
    }).catch((error) => {
      console.log(error);
      reject(error)
    })
  })
}
/**
 * methods 请求为POST
 * data 请求格式
 */

function postByToken(url, data,sxToken,config={ timeout: 20 * 1000 }) {
  const { timeout } = config;
  let headers = filterHeaderNew();
  headers['SX-TOKEN'] = sxToken;
  let apiUrl =Api_Base_Url_Cahd ? (Api_Base_Url_Cahd + url):url;
  return new Promise((resolve, reject) => {
    axios.request({
      url: apiUrl,
      method: 'post',
      data: data,
      timeout,
      transformRequest: [
        function (data) {
          data = JSON.stringify(data)
          return data
        }
      ],
      headers
    }).then(res => {
      resolve(res)
    }).catch((error) => {
      console.log(error);
      reject(error)
    })
  })
}

/**
 * methods请求为POST
 * data请求为JSON格式
 */
function postJson(url, data, noUseToken, config={ timeout: 20 * 1000 }) {
  const { timeout } = config;
  let headers = filterHeader();
  return new Promise((resolve, reject) => {
    axios.request({
      url: Api_Base_Url_Cahd + url,
      method: 'post',
      data: data,
      timeout,
      transformRequest: [
        function (data) {
          data = JSON.stringify(data)
          return data
        }
      ],
      headers
    }).then(res => {
      resolve(res)
    }).catch((error) => {
      console.log(error);
      reject(error)
    })
  })
}

/**
 * methods请求为DELETE
 *
 */
function deleteM(url, params) {
  let headers = filterHeader();
  return new Promise((resolve, reject) => {
    axios.request({
      url: Api_Base_Url_Cahd + url,
      method: 'delete',
      params: params,
      headers
    }).then(res => {
      resolve(res)
    }).catch(error => {
      console.log(error);
      reject(error)
    })
  })
}

/**
 * methods请求为PUT
 * data请求为JSON格式
 */
function put(url, data) {
  let headers = filterHeader();
  return new Promise((resolve, reject) => {
    axios.request({
      url: Api_Base_Url_Cahd + url,
      //url:  url,
      method: 'put',
      data: data,
      headers
    }).then(res => {
      resolve(res)
    }).catch(error => {
      console.log(error);
      reject(error)
    })
  })
}

/**
 * @Description: 过滤请求头，默认加token和staffId
 *               当noUseToken参数为true时，请求头不加参数
*/
function filterHeader(noUseToken) {
  const userToken = sessionStorage.getItem("userToken");
  if (noUseToken) {
    return {}
  } else {
    return {
      Authorization: "SX-TOKEN " + userToken 
    };
  }
}

function filterHeaderNew(noUseToken) {
  // const userToken = sessionStorage.getItem("userToken");
  // const staffId = sessionStorage.getItem("staffId");
  if (noUseToken) {
    return {}
  } else {
    return {
      //'credentials': 'same-origin',
      'Content-Type': 'multipart/form-data'
    };
  }
}

export default {
  postJson,
  post,
  get,
  getPassport,
  getByToken,
  deleteM,
  put,
  postByToken
}

